<template>
  <div>
    <h5 class="h5-small">
      {{ person.first_name + " " + person.last_name }}
    </h5>
    <p v-if="person.function.length > 0" class="p-small" v-html="$t('activityDomain', {
        domain: person.function,
      })
      "></p>
    <p class="p-small" v-else> &nbsp;</p>
    <p v-if="person.city.length > 0" class="p-small" v-html="$t('cityDomain', {
        city: person.city,
      })
      "></p>
      <p class="h5-small" >
      {{
        this.person.company_name
      }}
    </p>
    <p v-if="person.company_city.length > 0" class="p-small" v-html="$t('companyCityDomain', {
        city: person.company_city,
      })
      "></p>
    <p class="p-small" ><i>
      {{
        this.person.company_description
      }}
      </i>
    </p>
    <div class="contact-details-wrapper">
      <a v-if="!admin && !isFriend" class="button-all button-orange" :class="!person.open_bussiness && 'disabled-anchor'"
        @click="addFriend">{{
          $t("addFriendLabel")
        }}</a>
      <div v-else style="height: 54px"></div>
      <PersonContactOnly :person="person" />

    </div>
  </div>
</template>

<script>
import { VBTooltip } from "bootstrap-vue";
import $ from "jquery";
import PersonContactOnly from "@/components/fragments/PersonContactOnly.vue";

export default {
  name: "PersonContact",
  props: {
    person: Object,
    admin: Boolean,
    isFriend: Boolean
  },
  components: { PersonContactOnly },

  directive: {
    "v-b-tooltip": VBTooltip
  },
  data() {
    return {
      // offer: null,
    };
  },
  methods: {
    addFriend() {
      this.$emit("addFriend", this.person.id);
    },
    isDisabled() {
      return this.person.open_bussiness == false ? 1 : 0;
    }
  },
  mounted() {
    if (this.person.open_bussiness) {
      $("#contact" + this.person.id).prop('disabled', false);
    } else {
      $("#contact" + this.person.id).prop('disabled', true);
    }
  }
  // computed: {
  //   isDisabled(){
  //   }
  // }
};
</script>
<style scoped src="@/assets/styles/beneficiary.css" />

<style scoped>
.contact-details-wrapper {
  max-width: 262px;
  min-width: 235px;
}

.p-small{
  margin-bottom: 1px !important;
}

.h5-small {
  margin-top: 5px;
  margin-bottom: 0px;
}

</style>
